import React, { useState, useEffect, useRef } from "react";
import Translations from "../../services/translation.service";
import PaciService from "../../services/paci_connection.service";
import StmSummary from "../shared/storefront-summary";
import StorefrontTitle from "../shared/storefront-title.component";
import moment from "moment";
import User from "../../services/user.service";
import Storage from "../../services/storage.service";
import DownloadAppLinks from '../../ui/download_app_links';
import Settings from "../../services/settings.service";
import PaciQRFailure from './paci-qr-failure.component';
import CONSTANTS from "../../services/constants.service";
import SpinnerTimeLoader from "../shared/timeLoading";

const subscriptions = [];
const PaciQR = (props) => {
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(null);
  const [pending, setPending] = useState(false);
  const [paciResponse, setPaciResponse] = useState(null);
  const [qrCode, setQRCode] = useState(null);
  
  const timerRef = useRef();

  useEffect(() => {
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );

    initiatePaci();

    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
      clearTimer();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  const initiatePaci = () => {
    setLoading(true);
    setPending(true);
    setPaciResponse(null);
    PaciService.initiate()
        .then(response => {
            setLoading(false);
            if(response?.data?.HasPACI) {
                setQRCode(response?.data?.QRCodeImage)
                updateTimer();
                fetchTimerValue();        
            }
        })
        .catch(error => {
            setLoading(false);
            clearTimer();
            console.error('paci check catch issue:', error);
        })
    }

        const fetchTimerValue = () => {
            let business = JSON.parse(Storage.get("business", true)) || {};
            if (business["paci_timer_seconds"] || business["paci_timer_seconds"] === 0) {
                setTimer(business["paci_timer_seconds"]);
            }
        }

      const checkPaciConnection = () => {
          setPending(false);
          setPaciResponse(null);
          Storage.clear("PACIActvivationPending");
          PaciService.status()
              .then(response => {
                  if (response && response?.data && response?.data?.Status && response?.data?.Status === 3) {
                      if(response?.data?.Email) {
                        Storage.set("retrievedEmail", response?.data?.Email, true);
                      }
                      if(response?.data?.isAddSimFlow) {
                        Storage.set("isAddSimFlow", response?.data?.isAddSimFlow, true);
                      }
                      if(response?.data?.Status === CONSTANTS.PACI_STATUS.ACTIVATED) {
                        if(response && response?.data && response?.data?.EligibilityStatus && response?.data?.EligibilityStatus === CONSTANTS.PACI_STATUS.ACTIVATION_PENDING) {
                            Storage.set("PACIActvivationPending", true, true)
                            clearTimer();
                            setTimer(null);
                            setPaciResponse("failed");
                        } else {
                            clearTimer();
                            User.updateFlowStatus("selfie_submitted", true).then(() => {
                                setPaciResponse("success");
                                User.fetchFlowStatus();
                              }).catch(() => {
                            });
                        }
                      }
                  } else if (response && response?.data && response?.data?.Status && response?.data?.Status === CONSTANTS.PACI_STATUS.FAILED) {
                      if(response?.data?.TryAgainEligibility) {
                        Storage.set("TryAgainEligibility", response?.data?.TryAgainEligibility, true)
                      }
                      clearTimer();
                      setTimer(null);
                      setPaciResponse("failed");
                  } else {
                    setPaciResponse("unknown");
                    setPending(true);
                  }
              })
              .catch(error => {
                  clearTimer();
                  console.error('paci check catch issue:', error);
              })
      }

    const updateTimer = () => {
        timerRef.current = setInterval(() => {
            setTimer((prevTimer) => {
                if (prevTimer <= 0) {
                    clearInterval(timerRef.current);
                    return 0;
                }
                return prevTimer - 1;
            });
        }, 1000);
    };

    const clearTimer = () => {
        clearInterval(timerRef.current);
        timerRef.current = null;
    }

    const getTime = () => {
        let datM = moment.duration(timer, "seconds").minutes();
        let datS = moment.duration(timer, "seconds").seconds();
        datM = `${datM > 9 ? datM : `0${datM}`}`;
        datS = `${datS > 9 ? datS : `0${datS}`}`;
        return `${datM}:${datS}`;
    }

    useEffect(() => {
        if (timer === 0) {
            setPaciResponse("unknown");
            setTimer(null);
        }
        if (pending && timer % 15 === 0 && timer < 300 && timer > 0) {
            checkPaciConnection();
        }
    }, [timer]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (paciResponse === "failed" ||  paciResponse === "pending") {
            clearTimer();
        }
    }, [paciResponse])

    const retryHandling = () => {
        initiatePaci();
    }

  return (
    <>
    {timer === null && (paciResponse === "failed" || paciResponse === "unknown" || paciResponse === "pending") ?
        <PaciQRFailure
            history={props.history}
            retryHandling={retryHandling}
        /> :
        <>
            <div className="storefront-two-col-pg">
                <div className="stf-scan-id-page">
                    <StorefrontTitle
                    title={translationKeys["ob_verify_with_paci"] || "Verify with PACI"}
                    desc={translationKeys["ob_ocr_you_can_continue_entering_idx"]}
                    />
                    <ul className="stf-paci-steps">
                        <li>{translationKeys["ob_verify_with_paci_step1"] || "1. Open the PACI Mobile ID app"}</li>
                        <li>{translationKeys["ob_verify_with_paci_step2"] || "2. Tap “Scan QR Code”"}</li>
                        <li>{translationKeys["ob_verify_with_paci_step3"] || "3. Point your camera at the this code"}</li>
                    </ul>
                    {loading ? <SpinnerTimeLoader/> :
                        <div className="paci-qr-container">
                            <span>{translationKeys["ob_qr_expires"] || "QR Code expires in"}</span>
                            <span className="paci-qr-timer">{getTime()}</span>
                            {qrCode && <div>
                                <img src={`data:image/png;base64,${qrCode}`} alt="" />
                            </div>}
                        </div>
                    }
                    <span className="paci-app-download-title">{translationKeys["ob_download_paci"] || "Don’t have PACI? Download here"}</span>
                    <DownloadAppLinks
                        classes={"download-app-container-btns-area"}
                        google_play_link={Settings.google_play_link_paci}
                        app_store_link={Settings.app_store_link_paci}
                    />
                </div>
                <StmSummary />
            </div>
        </>
        }
    </>
  );
};

export default PaciQR;
